module.exports = __webpack_public_path__ + "img/icon_map_51_on_101.00743af2.png";